import { render, staticRenderFns } from "./LockForm.vue?vue&type=template&id=f0944ac8&scoped=true"
import script from "./LockForm.vue?vue&type=script&lang=js"
export * from "./LockForm.vue?vue&type=script&lang=js"
import style0 from "./LockForm.vue?vue&type=style&index=0&id=f0944ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0944ac8",
  null
  
)

export default component.exports